import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Account.requests'

const useGetAccount = (id: number) => {
    return useRequest({
        key: RequestKeys.getAccount,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
    })
}

export default useGetAccount
